import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "./shared";
import { DEVICE_SLIDES } from "./content";

export const DeviceSlider = () => {
  const [i, setI] = useState(0);
  const go = (n) => setI((n + DEVICE_SLIDES.length) % DEVICE_SLIDES.length);
  return (
    <div data-testid="device-slider">
      <div className="relative rounded-3xl overflow-hidden border border-white/10 bg-[#060C1C]">
        {DEVICE_SLIDES.map((s, idx) => (
          <img
            key={s.src}
            src={s.src}
            alt={s.alt}
            data-testid={`device-image-${idx}`}
            className={`w-full object-cover transition-opacity duration-500 ${idx === i ? "opacity-100" : "opacity-0 absolute inset-0 pointer-events-none"}`}
          />
        ))}
        <button
          onClick={() => go(i - 1)}
          data-testid="device-slide-prev"
          aria-label="Previous"
          className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#040814]/70 border border-white/15 backdrop-blur flex items-center justify-center text-white hover:bg-[#22D3EE]/30 hover:border-[#22D3EE]/60 transition-colors"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <button
          onClick={() => go(i + 1)}
          data-testid="device-slide-next"
          aria-label="Next"
          className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#040814]/70 border border-white/15 backdrop-blur flex items-center justify-center text-white hover:bg-[#22D3EE]/30 hover:border-[#22D3EE]/60 transition-colors"
        >
          <ChevronRight className="w-5 h-5" />
        </button>
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2">
          {DEVICE_SLIDES.map((s, idx) => (
            <button
              key={`dot-${s.src}`}
              onClick={() => go(idx)}
              data-testid={`device-slide-dot-${idx}`}
              aria-label={`Go to slide ${idx + 1}`}
              className={`h-2 rounded-full transition-all ${idx === i ? "w-6 bg-[#22D3EE]" : "w-2 bg-white/30 hover:bg-white/50"}`}
            />
          ))}
        </div>
      </div>
      <div className="bps-card bps-card-accent p-5 text-center mt-4 flex items-center justify-center gap-3">
        <div className="font-display text-4xl font-extrabold text-[#22D3EE] leading-none">70<span className="text-xl">lbs</span></div>
        <div className="text-[11px] uppercase tracking-[0.16em] text-[#9AAEC6] text-left">Pressure lifted<br />off your back</div>
      </div>
    </div>
  );
};
